import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-snoozed-mail-icon',
  templateUrl: './communication-snoozed-mail.component.html'
})
export class CommunicationSnoozedMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
